import React, { createContext, useContext, useState, useCallback } from 'react';

const ReggieContext = createContext(undefined);

export const ReggieProvider = ({ children }) => {
  const [stepContext, setStepContext] = useState({});
  const [isOpen, setIsOpen] = useState(false);

  const updateContext = useCallback((ctx) => {
    setStepContext(prev => ({ ...prev, ...ctx }));
  }, []);

  const clearContext = useCallback(() => {
    setStepContext({});
  }, []);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen(prev => !prev), []);

  return (
    <ReggieContext.Provider value={{
      stepContext,
      updateContext,
      clearContext,
      isOpen,
      open,
      close,
      toggle
    }}>
      {children}
    </ReggieContext.Provider>
  );
};

export const useReggie = () => {
  const context = useContext(ReggieContext);
  if (!context) {
    throw new Error('useReggie must be used within a ReggieProvider');
  }
  return context;
};
